// Open Grievances by Category — open/in_progress only, grouped by category,
// count + oldest-open age per group.
import React from "react";
import { ReportShell, Card, Pill, EmptyState } from "./_shared";
import { CATEGORIES, categoryLabel, OPEN_STATUSES, openAgeDays } from "../grievanceModel";

export default function OpenByCategory({ records = [] }) {
  const open = records.filter((r) => OPEN_STATUSES.includes(r.status));
  const groups = {};
  open.forEach((r) => {
    const k = r.category || "other";
    if (!groups[k]) groups[k] = { count: 0, oldest: null };
    groups[k].count += 1;
    const age = openAgeDays(r);
    if (age != null && (groups[k].oldest == null || age > groups[k].oldest)) groups[k].oldest = age;
  });
  const rows = Object.entries(groups).map(([key, g]) => ({ key, ...g })).sort((a, b) => b.count - a.count);

  return (
    <ReportShell title="Open Grievances by Category" subtitle={`${open.length} open (open + in progress) grievance${open.length === 1 ? "" : "s"} grouped by category.`}>
      {rows.length === 0 ? (
        <EmptyState>No open grievances for this scope — nicely done.</EmptyState>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 14 }}>
          {rows.map((r) => {
            const c = CATEGORIES[r.key] || {};
            const stale = r.oldest != null && r.oldest > 5;
            return (
              <Card key={r.key} style={{ borderLeft: `4px solid ${c.color || "#475569"}` }}>
                <div style={{ marginBottom: 10 }}><Pill label={categoryLabel(r.key)} color={c.color} bg={c.bg} /></div>
                <div style={{ fontSize: 34, fontWeight: 800, color: "var(--ed-ink)", lineHeight: 1 }}>{r.count}</div>
                <div style={{ fontSize: 12, color: "var(--ed-muted)", marginTop: 2 }}>open</div>
                <div style={{ fontSize: 12.5, marginTop: 10, color: stale ? "var(--ed-alert)" : "var(--ed-ink-3)", fontWeight: stale ? 700 : 500 }}>
                  Oldest open: {r.oldest == null ? "—" : `${r.oldest} day${r.oldest === 1 ? "" : "s"}`}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </ReportShell>
  );
}
